import React, { useState } from "react";
import "../css/BookAppointment.css"; // Import the external CSS file

function BookAppointment() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    number: "",
    date: "",
    description: "",
  });

  const [submitted, setSubmitted] = useState(false); // State to track form submission

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, number, date, description } = formData;

    // Construct the mailto link with the form data
    const mailtoLink = `mailto:dentingobi@gmail.com?subject=Appointment Request&body=Name: ${name}%0AEmail: ${email}%0APhone Number: ${number}%0ADate: ${date}%0ADescription: ${description}`;

    // Open the default email client with the pre-filled details
    window.location.href = mailtoLink;

    // Clear form fields and show submission status
    setFormData({
      name: "",
      email: "",
      number: "",
      date: "",
      description: "",
    });
    setSubmitted(true);

    // Reset submission status after 3 seconds
    setTimeout(() => setSubmitted(false), 3000);
  };

  return (
    <div id="bgimg">
    <div className="book-appointment-container">
      <h2 style={{fontWeight:"700"}}>Book an Appointment</h2>
      <form
        onSubmit={handleSubmit}
        className={`book-appointment-form ${submitted ? "submitted" : ""}`}
      >
        <div className="inputGroup">
          <label className="label">Name:</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="input"
            placeholder="Your Name"
            maxLength="50"
          />
        </div>

        <div className="inputGroup">
          <label className="label">Email:</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="input"
            placeholder="example@email.com"
          />
        </div>

        <div className="inputGroup">
          <label className="label">Phone Number:</label>
          <input
            type="tel"
            name="number"
            value={formData.number}
            onChange={handleChange}
            className="input"
            placeholder="1234567890"
            maxLength="10"
          />
        </div>

        <div className="inputGroup">
          <label className="label">Date:</label>
          <input
            type="date"
            name="date"
            value={formData.date}
            onChange={handleChange}
            className="input"
          />
        </div>

        <div className="inputGroup">
          <label className="label">Description:</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            className="textarea"
            placeholder="Describe your request"
            rows="4"
          />
        </div>

        <div className={`buttonContainer ${submitted ? "centered" : ""}`}>
          <input
            className={`button ${submitted ? "animate" : ""}`}
            type="submit"
            value="Send"
          />
        </div>
      </form>
    </div>
    </div>
  );
}

export default BookAppointment;
